import { render } from "./GoogleButton.vue?vue&type=template&id=07f76df3"
const script = {}

import "./GoogleButton.vue?vue&type=style&index=0&id=07f76df3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__